import createIcon from '../../createIcon';

/**
 * @component @name Sevenk
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk05LjUgMTVINy43NUw5LjEzIDEwLjVINi41VjlIMTBDMTAuNjcgOSAxMS4xNSA5LjY1IDEwLjk2IDEwLjI5TDkuNSAxNVpNMTggMTVIMTYuMjVMMTQuNSAxMi43NVYxNUgxM1Y5SDE0LjVWMTEuMjVMMTYuMjUgOUgxOEwxNS43NSAxMkwxOCAxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sevenk = createIcon('Sevenk', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9.5 15H7.75L9.13 10.5H6.5V9H10C10.67 9 11.15 9.65 10.96 10.29L9.5 15ZM18 15H16.25L14.5 12.75V15H13V9H14.5V11.25L16.25 9H18L15.75 12L18 15Z',
      key: 'qz3n2l',
    },
  ],
]);

export default Sevenk;
